<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import PAF03 from './PAF03.vue'


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ PAF03 ],
    computed: {
      itemsSuperRainbowSkyIR () {
        const index = _.findIndex(this.items, { id: 'IR04-16' })
        return this.items.slice(index, index + 4)
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[2,3,4,6,9]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="プリリズADCh|🥚 ER 🥚" color="#44cd1f" :items="collection('PRADCh', 'ER')" />
      <ItemList title="プリリズADCh|PR ★★★" color="#ffa1bc" :items="collection('PRADCh', 'PR')" />
      <ItemList title="プリリズADCh|SR ★★" color="#00c7da" :items="collection('PRADCh', 'SR')" />
    </template>

    <template #col2>
      <ItemList title="プリリズADCh|R ★" color="#feab0d" :items="collection('PRADCh', 'R')" />
    </template>

    <template #col3>
      <ItemList title="プリリズDMFCh|🥚 ER 🥚" color="#44cd1f" :items="collection('PRDMFCh', 'ER')" />
      <ItemList title="プリリズDMFCh|PR ★★★" color="#ffa1bc" :items="collection('PRDMFCh', 'PR')" />
    </template>

    <template #col4>
      <ItemList title="プリリズDMFCh|SR ★★" color="#00c7da" :items="collection('PRDMFCh', 'SR')" />
    </template>

    <template #col5>
      <ItemList title="プリリズRLCh|🥚 ER 🥚" color="#44cd1f" :items="collection('PRRLCh', 'ER')" />
      <ItemList title="プリリズRLCh|PR ★★★" color="#ffa1bc" :items="collection('PRRLCh', 'PR')" />
      <ItemList title="プリリズRLCh|SR ★★" color="#00c7da" :items="collection('PRRLCh', 'SR')" />
    </template>

    <template #col6>
      <ItemList title="プリリズRLCh|R ★" color="#feab0d" :items="collection('PRRLCh', 'R')" />
    </template>

    <template #col7>
      <ItemList title="プリティーコレクション3|ニコチケ PR ★★★" color="#ffa1bc" :items="collection('PrettyCollection3', 'PR') | first(8 * 4)" />
    </template>

    <template #col8>
      <ItemList title="プリティーコレクション3|ニコチケ PR ★★★" color="#ffa1bc" :items="collection('PrettyCollection3', 'PR') | rest(8 * 4)" :isOrphan="true" />
    </template>

    <template #col9>
      <ItemList title="プリティーコレクション3|ニコチケ SR ★★" color="#00c7da" :items="collection('PrettyCollection3', 'SR')" />
      <ItemList title="イルミナージュコーデ|✨ IR ✨" color="#edd50f" :items="itemsSuperRainbowSkyIR" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
